import { render, staticRenderFns } from "./ngo-registered-details.vue?vue&type=template&id=4a4214be&scoped=true&"
import script from "./ngo-registered-details.vue?vue&type=script&lang=js&"
export * from "./ngo-registered-details.vue?vue&type=script&lang=js&"
import style0 from "./ngo-registered-details.vue?vue&type=style&index=0&id=4a4214be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4214be",
  null
  
)

export default component.exports